import {
    CounsellingsHomePageState,
    initialCounsellingsHomePageState,
} from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.reducers';
import { getForumComplaintsStatistics } from 'mk2/apps/forum/reducers';
import { ComplaintsCountPerTopic, CounsellingEntity, CounsellingSchema } from 'mk2/apps/forum/schemas';
import { AppState } from 'mk2/reducers';
import { getDenormalizedEntities } from 'mk2/selectors';
import { createSelector } from 'reselect';

export const getCounsellingsHomePageState = (state: AppState): CounsellingsHomePageState =>
    state.containers.counsellings.home || initialCounsellingsHomePageState;

export const getCounsellingsHomeComplaintsStatisticsPerTopic = createSelector(
    [
        (state: AppState) => getDenormalizedEntities<CounsellingEntity>(state, CounsellingSchema, getCounsellingsHomePageState(state).counsellingIds),
        (state: AppState) => getForumComplaintsStatistics(state),
    ],
    (counsellings, complaintsStatistics) => {
        if (!counsellings.length) {
            return {};
        }

        const keys = Object.keys(complaintsStatistics).map(parseInt);
        return counsellings.reduce((acc: ComplaintsCountPerTopic, cur: CounsellingEntity) => {
            acc[cur.topic.id] = keys.reduce((acc2, cur2) => {
                const current = complaintsStatistics[cur2];
                if (!current || current.topicId !== cur.topic.id) {
                    return acc2;
                }

                return acc2 + current.count;
            }, 0);
            return acc;
        }, {});
    },
);
